<template>
  <div class="site-logo-holder">
    <p class="site-logo"><router-link to="/"><span class="elr-uppercase">MyLittlePony</span>Collection</router-link></p>
  </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';
.site-logo {
  font-size: 24px;

  a {
    color: $text-color;
    text-decoration: none;
  }

  .elr-uppercase {
    font-size: 30px;
    font-weight: 900;
    color: $accent-color;
  }
}
</style>

